import { DAPStatusEnum } from '@ytl/common-model';
import { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/languageContext';
import { OnboardingMethod } from '../../shared/@types/onboardingMethods';
import { WidgetEvent } from '../../shared/@types/widgetEvents';
import { NoSubscriberFound } from '../../shared/components/partials/onboarding/NoSubscriberFound';
import { Banned } from '../../shared/components/partials/verification/Banned';
import { onWidgetEvent } from '../../shared/utils/emitData';
import { OnboardingComponent } from './OnboardingComponent';

type OnboardingProps = {
  exitButtonAction: () => void;
  method?: OnboardingMethod;
};

export const OnboardingView = ({ exitButtonAction, method }: OnboardingProps) => {
  const { translation } = useLanguage();
  const [isBanned, setIsBanned] = useState(false);
  const [noSubscriberFound, setNoSubscriberFound] = useState(false);

  useEffect(() => {
    const cleanup = onWidgetEvent((data: any) => {
      console.log('Received widget event in OnboardingView:', data);

      switch (data.eventName) {
        case WidgetEvent.DAPStatusReport:
          console.log('DAPStatusReport:', data.eventValue);
          if (data.eventValue?.error === DAPStatusEnum.NO_SUBSCRIBER_FOUND) {
            setNoSubscriberFound(true);
          }
          break;
        case WidgetEvent.ProcessFinished:
          if (!data.isSuccess && data.eventValue?.banned) {
            setIsBanned(true);
          }
          break;
        default:
          break;
      }
    });

    return cleanup;
  }, []);

  return (
    <>
      {isBanned ? (
        <Banned buttonAction={exitButtonAction} />
      ) : noSubscriberFound ? (
        <NoSubscriberFound />
      ) : (
        <div className="register-page">
          <div className="register-page__wrapper">
            <div className="register-page__container">
              <div className="register-page__container__box">
                <OnboardingComponent method={method} />
              </div>
            </div>

            <div className="register-page__hero">
              <div className="register-page__hero__content">
                <h1>{translation.onboarding.hero.heroTitle}</h1>
                <p>{translation.onboarding.hero.heroSubtitle}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
